// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3MnDs","info":"PatientInfo_info__2nusl"};